import { queryKeys } from '@/lib/query-keys';
import type { SessionResponse } from '@/lib/session';
import { apiClient } from '@borradh-workspace/api-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useRef } from 'react';
import { z } from 'zod';
import { type TestCallIntent, buildTestCallPayload } from './test-call.payload';

const resultSchema = z.object({
  callSid: z.string(),
  conversationId: z.string(),
});
export function useTestCall() {
  const client = useQueryClient();
  const requests = useRef(new Map<string, string>());
  return useMutation({
    mutationFn: (input: TestCallIntent) => {
      const candidate = buildTestCallPayload(input, crypto.randomUUID());
      const user = client.getQueryData<SessionResponse>(
        queryKeys.auth.session()
      )?.user;
      const requestKey = JSON.stringify([
        user?.id,
        user?.organizationId,
        candidate.phone,
      ]);
      const requestId = requests.current.get(requestKey) ?? candidate.requestId;
      requests.current.set(requestKey, requestId);
      return apiClient
        .post(
          'voice-receptionist/test-calls',
          requestId === candidate.requestId
            ? candidate
            : buildTestCallPayload(input, requestId),
          { schema: resultSchema }
        )
        .then((call) => ({ ...call, requestKey }));
    },
    onSuccess: (call) => {
      requests.current.delete(call.requestKey);
      void client.invalidateQueries({
        queryKey: queryKeys.voiceReceptionist.calls(call.conversationId),
      });
    },
  });
}
